/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
/* eslint-disable consistent-return */
/* eslint-disable react/button-has-type */
import { PlusIcon } from '@heroicons/react/24/solid';
import { Link } from 'react-router-dom';

const FAQCard = ({ title, description, path, href }) => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  return (
    <div>
      {href !== undefined && path === undefined ? (
        <a href={href}>
          <div className='bg-black h-fit min-w-96 w-fit shadow-lg rounded-xl my-4 flex flex-col hover:scale-105 cursor-pointer nft-card ease-in duration-500 relative py-4'>
            <div className='flex'>
              <div className='flex justify-center items-center basis-1/4'>
                <PlusIcon className='w-12 h-12 text-[#40A838]' />
              </div>
              <div className='basis-3/4'>
                <h1 className='font-bold text-white mx-4'>
                  {title.substring(0, 41)}
                </h1>
                <div className='mx-4 w-[325px]'>
                  <p className='text-xs text-gray-300 font-bold mt-2'>
                    {description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </a>
      ) : (
        <Link to={path} onClick={scrollToTop}>
          <div className='bg-black h-fit min-w-96 w-fit shadow-lg rounded-xl my-4 flex flex-col hover:scale-105 cursor-pointer nft-card ease-in duration-500 relative py-4'>
            <div className='flex'>
              <div className='flex justify-center items-center basis-1/4'>
                <PlusIcon className='w-12 h-12 text-[#40A838]' />
              </div>
              <div className='basis-3/4'>
                <h1 className='font-bold text-white mx-4'>
                  {title.substring(0, 41)}
                </h1>
                <div className='mx-4 w-[325px]'>
                  <p className='text-xs text-gray-300 font-bold mt-2'>
                    {description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Link>
      )}
    </div>
  );
};

export default FAQCard;
